import {
  WHITE,
  TEXT_COLOR,
  TITLE_COLOR_GK,
  SECONDARY_BTN_GK,
  FADE_BG_GK,
  FOOTER_BG_GK,
} from "../../utils/colors";

import {
  TITLE_SIZE,
  SUB_TITLE_SIZE,
  TEXT_SIZE,
  SUB_TEXT_SIZE,
} from "../../utils/fonts";

import { useEffect } from "react";
import DynamicTitle from "../../components/DynamicTitle";
import BannerSection from "../../components/BannerSection";
import { HiOutlineNewspaper } from "react-icons/hi2";
import FooterBar from "../../components/FooterBar";
import Destaque from "../../assets/images/news.webp";
import AllPosts from "../../components/AllPosts";
import "./Destaques.css";

export default function Destaques() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="Noticias">
      <DynamicTitle
        pageTitle="Grupo Krause - Destaques"
        pageMeta="Grupo Krause"
        pageContent="Fique por dentro das nossas novidades, artigos e notícias."
      />
      <BannerSection
        white={WHITE}
        fadeBG={FADE_BG_GK}
        iconTitle={
          <HiOutlineNewspaper
            style={{ color: WHITE }}
            className="banner-section-icon"
          />
        }
        bannerTitle={"DESTAQUES"}
        bannerTitleSize={TITLE_SIZE}
        bannerSubTitle={
          "Fique por dentro das nossas novidades, artigos e notícias."
        }
        bannerSubTitleSize={SUB_TITLE_SIZE}
        bannerBG={Destaque}
        bannerBGmobile={Destaque}
      />
      <AllPosts
        white={WHITE}
        titleColor={TITLE_COLOR_GK}
        textColor={TEXT_COLOR}
        subTitleSize={SUB_TITLE_SIZE}
        textSize={TEXT_SIZE}
        subTextSize={SUB_TEXT_SIZE}
        btnColor={SECONDARY_BTN_GK}
      />
      <FooterBar titleColor={TITLE_COLOR_GK} footerBarBG={FOOTER_BG_GK} />
    </div>
  );
}
